import React, { useState } from "react";
import { View, TextInput } from "react-native";

function InputComponent(props) {
  const [value, setValue] = useState(props.value);

  function handleOnChange(newValue) {
    setValue(newValue);
    if (props.onChange) {
      props.onChange(newValue);
    }
  }

  return (
    <View style={{ width: "100%" }}>
      <TextInput
        value={value}
        type="text"
        onChangeText={handleOnChange}
        placeholder={props.placeholder}
        style={{ textAlign: "center", marginTop: 5, backgroundColor: "white" }}
      />
    </View>
  );
}

export default InputComponent;
